import { combineReducers } from 'redux';

import { auth } from '../modules/auth/reducers';
import { config } from './config.reducer';
import { students } from '../modules/students/reducers';
import { school } from '../modules/schools/reducers';

import { view } from './view.reducer';
import { courses } from '../modules/courses/reducers';
import { search } from '../modules/search/reducers';
import { personas } from '../modules/personas/reducers';

import { setup } from '../modules/setup/reducers';


import { tutors } from '../modules/tutors/reducers';
import { teachers } from '../modules/teachers/reducers';

import { home } from '../modules/home/reducers';

import { admin } from '../modules/admin/reducers';

const rootReducer = combineReducers({
   auth ,
   config,
   students,
   view,
   school,
   courses,
   search,
   personas,
   setup,
   tutors,
   teachers,
   home,
   admin
});

export default rootReducer;